<div class="tabheadingsoverflow">
    <h2  class="mainhead "><span class="text">Broker Opinion of Value</span></h2>
    <div class="table-responsive margin-bottom-20 margin-top-30" *ngIf="IsAdmin || IsBroker">
        <table class="table basictable">
            <thead>
              <tr>
                <th data-orderable="false" width="130px"></th>
                <th data-orderable="false">Action</th>
                <th>Document Title</th>
                <th>Uploaded By</th>
                <th>Date</th>

              </tr>
            </thead>
            <tbody *ngIf="document != null && document != undefined && document.Id > 0 ">
              <tr>
                <td>
                  <div *ngIf="document.Url != null && document.Url.length > 0 && document.Thumbnail != null && document.Url.includes('.pdf')">
                    <span (click)="previews(preview,'pdf-view-modal', document)"> <img height="150" [src]="imageURL" /></span>

</div>
                </td>
                <td>
                  <a href="javascript:void(0);" (click)="removeModel(removeDoc,'deletemodal', document)" class="remove" tooltip="Remove" placement="top">
                    <i class="icofont icofont-close" aria-hidden="true"></i>
                  </a>
                  <a style="padding-left:5px" *ngIf="document.Url != null && document.Url != undefiend && document.Url.length > 0" tooltip="Download" href="{{document.Url}}" download target="_blank">
                    <i aria-hidden="true" class="icofont icofont-download-alt"></i>
                  </a>
                </td>
                <td>
                  <p>{{document.Name}}</p>
                </td>
                <td>
                  <p>{{document.UploadedBy}}</p>
                </td>
                <td>
                  <p>{{document.UploadedDate | date:"MM/dd/yyyy"}}</p>
                </td>

              </tr>
            </tbody>
            <tfoot>
                <tr *ngIf="document == undefield || document == null || document.Id == null || document.Id == undefield || document.Id == 0">
                    <td colspan="8" class="odd no-data-available">
                        <div class="nodata">
                            <i class="fa fa-exclamation-triangle icon"></i>
                            <p>No Data Available</p>
                        </div>
                    </td>
                </tr>
            </tfoot>
        </table>
    </div>
    <div class="offredetailspage section-margin" *ngIf="IsAdmin  || IsBroker">
        <div class="container">
            <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="floatinghead clearfix">
                        <file-upload [uploadType]="fileUploadType" (selectedFilesListEmitter)=selectedFilesListEmitter($event) [maxFiles]="5" [showList]="false" [fileDocExt]="'pdf,xlsx,doc,docx,xls,txt,dwg'" [extensionType]="fileExtensionType" [clearFilescounter]="clearFiles" [fileTypes]="fileTypes"></file-upload>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div>
        <div *ngIf="IsSeller">
            <div>
              <div>
                <div *ngIf="document.Url != null && document.Url.length > 0 && document.Thumbnail != null" class="td-Pdf-view margin-top-30" style="height:170px">
                  <img height="150" [src]="imageURL" />
                </div>
                
                <p class="pdf-file-name">{{document.Name}}</p>
              </div>
                <div class="margin-top-30 d-felx">
                    <p *ngIf="document.Id == null || document.Id == undefined || document.Id == 0" class="info-text margin-bottom-20">Your BOV will be ready to review soon! </p>
                    <a style="color:#fff !important;" *ngIf="document.Url != null && document.Url.length > 0" class="btn btn-success btn-lg" href={{document.Url}} download target="_blank" placement="top" tooltip="Download" ng-reflect-tooltip="Download" ng-reflect-placement="top" triggers="hover" (click)="saveBOVDownloadToAuditLog(document.Id,'Download')">
                        Download
                    </a>

                    <button *ngIf="document.Id != null && document.Id != undefined && document.Id > 0" class="btn btn-default btn-lg margin-left-15">
                        <!--       <a *ngIf="document.Url != null && document.Url.length > 0" class="btn btn-default btn-lg" href={{document.Url}} download target="_blank" placement="top" tooltip="Download" ng-reflect-tooltip="Download" ng-reflect-placement="top" triggers="hover">-->
                        <span (click)="previews(preview,'pdf-view-modal', document)">Preview</span>
                        <!--   </a>-->
                    </button>


                </div>
            </div>
        </div>

    </div>


    <!--<ngx-extended-pdf-viewer [src]="document.Url" useBrowserLocale="true" height="80vh"></ngx-extended-pdf-viewer>-->

</div>

<ng-template #template>

    <div class="modal-header">
        <h4 class="modal-title pull-left">Update BOV Document ?</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body padding30">

        <div class="form-group">
            <h6 class="displayvalue">Are you sure you'd like to update/upload the BOV document?</h6>
        </div>
        <div class="text-right">
            <button class="btn btn-lg btn-default" (click)="removeModalRef.hide()">Cancel</button>
            <button class="btn btn-lg btn-danger" (click)="onRemoveDocument();removeModalRef.hide();">Update</button>
        </div>
    </div>
</ng-template>

<ng-template #preview>
  <div class="modal-header">
    <h4 class="modal-title pull-left">{{document.Name}}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="documentPreview.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <ngx-extended-pdf-viewer [src]="document.Url" [showBookmarkButton]="false" useBrowserLocale="true" height="80vh"></ngx-extended-pdf-viewer>
</ng-template>

<ng-template #removeDoc>

    <div class="modal-header">
        <h4 class="modal-title pull-left">Delete Document?</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="removeDocModalRef.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body padding30">

        <div class="form-group">
            <h6 class="displayvalue">Are you sure to delete?</h6>
        </div>
        <div class="text-right">
            <button class="btn btn-lg btn-default" (click)="removeDocModalRef.hide()">Cancel</button>
            <button class="btn btn-lg btn-danger" (click)="deleteDoc();removeDocModalRef.hide();">Delete</button>
        </div>
    </div>
</ng-template>
